/**
 * WoodiesONWoodlawn — AJAX Add to Cart with Cinematic Feedback
 * Intercepts product form submission, POSTs via fetch to /cart/add.js,
 * dispatches woodies:cart-updated, and provides boutique-quality UI feedback.
 */
(function() {
  'use strict';

  /* ─── CONFIG ─── */
  var BUTTON_LOADING_TEXT = 'Curating\u2026';
  var BUTTON_SUCCESS_TEXT = 'ADDED!';
  var SUCCESS_REVERT_MS = 2200;
  var NOTIFICATION_DISMISS_MS = 3800;

  /* ─── INJECT NOTIFICATION STYLES ─── */
  var styleEl = document.createElement('style');
  styleEl.textContent = [
    '.woodies-notif{position:fixed;top:28px;right:28px;z-index:99999;pointer-events:none;display:flex;flex-direction:column;align-items:flex-end;gap:12px;}',
    '.woodies-notif__toast{pointer-events:auto;background:rgba(10,15,33,0.96);border:1px solid rgba(194,85,42,0.35);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border-radius:12px;padding:18px 28px;display:flex;align-items:center;gap:14px;transform:translateX(120%);opacity:0;transition:transform 0.45s cubic-bezier(0.165,0.84,0.44,1),opacity 0.4s ease;box-shadow:0 12px 40px rgba(0,0,0,0.55);}',
    '.woodies-notif__toast.is-visible{transform:translateX(0);opacity:1;}',
    '.woodies-notif__toast.is-exiting{transform:translateX(120%);opacity:0;}',
    '.woodies-notif__icon{width:32px;height:32px;border-radius:50%;background:#126180;display:flex;align-items:center;justify-content:center;flex-shrink:0;}',
    '.woodies-notif__icon svg{width:16px;height:16px;fill:none;stroke:#fff;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;}',
    '.woodies-notif__text{font-family:"Inter",sans-serif;color:#fff;font-size:14px;font-weight:500;letter-spacing:0.02em;line-height:1.4;}',
    '.woodies-notif__sub{font-size:12px;color:rgba(255,255,255,0.5);margin-top:3px;font-weight:400;}',
    '.p-main-btn.is-loading{opacity:0.65;pointer-events:none;cursor:wait;}',
    '.p-main-btn.is-success{background:#1A7A4C !important;transform:scale(1.02);}',
    '@media(max-width:600px){.woodies-notif{top:16px;right:16px;left:16px;align-items:stretch;}.woodies-notif__toast{padding:14px 18px;}}'
  ].join('\n');
  document.head.appendChild(styleEl);

  /* ─── INJECT NOTIFICATION CONTAINER ─── */
  var notifContainer = document.createElement('div');
  notifContainer.className = 'woodies-notif';
  notifContainer.setAttribute('aria-live', 'polite');
  notifContainer.setAttribute('aria-atomic', 'true');
  document.body.appendChild(notifContainer);

  /* ─── SHOW TOAST NOTIFICATION ─── */
  function showToast(title, subtitle) {
    var toast = document.createElement('div');
    toast.className = 'woodies-notif__toast';
    toast.innerHTML = [
      '<div class="woodies-notif__icon"><svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg></div>',
      '<div><div class="woodies-notif__text">' + title + '</div>',
      subtitle ? '<div class="woodies-notif__sub">' + subtitle + '</div>' : '',
      '</div>'
    ].join('');
    notifContainer.appendChild(toast);

    // Trigger entrance
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        toast.classList.add('is-visible');
      });
    });

    // Dismiss after delay
    setTimeout(function() {
      toast.classList.add('is-exiting');
      toast.classList.remove('is-visible');
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 500);
    }, NOTIFICATION_DISMISS_MS);
  }

  /* ─── SHOW ERROR TOAST ─── */
  function showErrorToast(message) {
    var toast = document.createElement('div');
    toast.className = 'woodies-notif__toast';
    toast.innerHTML = [
      '<div class="woodies-notif__icon" style="background:#8B2020"><svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></div>',
      '<div><div class="woodies-notif__text">' + message + '</div></div>'
    ].join('');
    notifContainer.appendChild(toast);

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        toast.classList.add('is-visible');
      });
    });

    setTimeout(function() {
      toast.classList.add('is-exiting');
      toast.classList.remove('is-visible');
      setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 500);
    }, 4500);
  }

  /* ─── OPEN MINI CART ─── */
  function openMiniCart() {
    var miniCartRoot = document.querySelector('[data-mini-cart]');
    if (!miniCartRoot) return;
    var panel = miniCartRoot.querySelector('.mini-cart');
    if (panel) {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
    }
    // Also open backdrop
    var backdrop = document.querySelector('.mini-cart__backdrop');
    if (backdrop) backdrop.classList.add('is-open');
  }

  /* ─── UPDATE HEADER CART COUNT ─── */
  function updateCartCount(count) {
    var countEls = document.querySelectorAll('[data-mini-cart-count]');
    countEls.forEach(function(el) {
      el.textContent = count || 0;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ─── INTERCEPT PRODUCT FORM ─── */
  function initAjaxCart() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    if (!forms.length) return;

    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var btn = form.querySelector('.p-main-btn') || form.querySelector('[type="submit"]');
        if (!btn) return;

        // Capture the ORIGINAL button text before we change it
        var originalText = btn.textContent.trim();

        // Loading state
        btn.textContent = BUTTON_LOADING_TEXT;
        btn.classList.add('is-loading');
        btn.disabled = true;

        // Prepare form data
        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function(response) {
          if (!response.ok) {
            return response.json().then(function(err) {
              throw new Error(err.description || err.message || 'Unable to add item.');
            });
          }
          return response.json();
        })
        .then(function(item) {
          // Fetch full cart for the event
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              // Dispatch custom event for mini-cart
              var event = new CustomEvent('woodies:cart-updated', {
                bubbles: true,
                detail: { cart: cart, addedItem: item }
              });
              document.dispatchEvent(event);

              // Update header cart count
              updateCartCount(cart.item_count);

              // Button success state
              btn.textContent = BUTTON_SUCCESS_TEXT;
              btn.classList.remove('is-loading');
              btn.classList.add('is-success');

              // Show notification
              showToast('Item Added to Cart', item.product_title || item.title);

              // Open mini-cart
              openMiniCart();

              // Revert button after delay — uses captured originalText
              setTimeout(function() {
                btn.textContent = originalText;
                btn.classList.remove('is-success');
                btn.disabled = false;
              }, SUCCESS_REVERT_MS);
            });
        })
        .catch(function(error) {
          console.error('[WoodiesONWoodlawn] Add to cart error:', error);
          // Revert uses captured originalText instead of hardcoded constant
          btn.textContent = originalText;
          btn.classList.remove('is-loading');
          btn.disabled = false;
          showErrorToast(error.message || 'Unable to add item. Please try again.');
        });
      });
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAjaxCart);
  } else {
    initAjaxCart();
  }
})();
